import { tpoStatusConfigurationApi } from 'app/services/api';

import { SKIP_FORBIDDEN_RESPONSE_CONFIG } from 'constants/http';
import { catchAsyncActionError } from 'utils/action';
import { getConditionalObject } from 'utils/data';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectTpoStatusDefinitionsList } from '../selectors/tpoStatusDefinitions.selectors';

export const TPO_STATUS_DEFINITIONS_ACTION_TYPE = createNamedActions('tpoStatusDefinitions', {
  GET_LIST: 'GET_LIST',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  REORDER: 'REORDER',
});

export const getTpoStatusDefinitionsAction = catchAsyncActionError(
  ({ isForbiddenSilent = false } = {}) =>
    async dispatch => {
      const { data } = await tpoStatusConfigurationApi.getTpoStatusDefinitions(
        getConditionalObject(isForbiddenSilent, SKIP_FORBIDDEN_RESPONSE_CONFIG),
      );

      return dispatch({ type: TPO_STATUS_DEFINITIONS_ACTION_TYPE.GET_LIST, payload: data });
    },
);

export const createTpoStatusDefinitionAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tpoStatusConfigurationApi.createTpoStatusDefinition(params);

  return dispatch({ type: TPO_STATUS_DEFINITIONS_ACTION_TYPE.CREATE, payload: data });
});

export const updateTpoStatusDefinitionAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tpoStatusConfigurationApi.updateTpoStatusDefinition(params);

  return dispatch({ type: TPO_STATUS_DEFINITIONS_ACTION_TYPE.UPDATE, payload: data });
});

export const deleteTpoStatusDefinitionAction = catchAsyncActionError(({ id }) => async dispatch => {
  await tpoStatusConfigurationApi.deleteTpoStatusDefinition({ id });

  return dispatch({ type: TPO_STATUS_DEFINITIONS_ACTION_TYPE.DELETE, payload: { id } });
});

/**
 * Applies the new order locally so the dropped row does not snap back while the request is in
 * flight, and restores the previous list if the server refuses it.
 */
export const reorderTpoStatusDefinitionsAction = catchAsyncActionError(
  ({ kind, orderedDefinitionIds }) =>
    async (dispatch, getState) => {
      const previousList = selectTpoStatusDefinitionsList(getState());

      dispatch({
        type: TPO_STATUS_DEFINITIONS_ACTION_TYPE.REORDER,
        payload: { kind, orderedDefinitionIds },
      });

      try {
        await tpoStatusConfigurationApi.reorderTpoStatusDefinitions({
          kind,
          orderedDefinitionIds,
        });
      } catch (error) {
        dispatch({ type: TPO_STATUS_DEFINITIONS_ACTION_TYPE.GET_LIST, payload: previousList });

        throw error;
      }
    },
);

export const dryRunTpoStatusDefinitionsAction = catchAsyncActionError(
  ({ tpoApplicationId = null, subCompanyId = null }) =>
    async () => {
      const { data } = await tpoStatusConfigurationApi.dryRunTpoStatusDefinitions({
        tpoApplicationId,
        subCompanyId,
      });

      return data;
    },
);
